<script lang="ts">
  import Label from '$provider/constants/Label';
  import type { DataListAlert } from '$provider/models/datalist/DataListAlert';
  import { ListAlertType } from '../ListAlertProps';
  import AlertView from './AlertView.svelte';
  import AlertText from './AlertText.svelte';
  import ToggleAction from './ToggleAction.svelte';
  import EditableListRow from '$shared/molecules/EditableListRow/EditableListRow.svelte';

  interface Props {
    alert: DataListAlert;
    onevent?: (payload: any) => void;
  }

  let { alert, onevent }: Props = $props();
</script>

<AlertView type={ListAlertType.ChangeTo} key={Label.ChangeTo} icon="icon-corner-down-right">
  {#snippet value()}
    <div  class="value" class:non-editable={!alert?.isEditable}>
      <EditableListRow active={alert?.isEditable} option={alert?.editableRow} {onevent}>
        <AlertText {alert} />
      </EditableListRow>
    </div>
  {/snippet}

  {#if alert?.showToggleAction}
    <ToggleAction {alert} {onevent} />
  {/if}
</AlertView>

<style>
  .value {
    width: 100%;
    font-weight: normal;
    font-size: 14px;
    line-height: 22px;
    padding: 8px 14px;
  }
  .value.non-editable {
    height: inherit;
    display: flex;
    align-items: center;
  }
</style>
